import React from 'react'
import { useGetQuestionnaire } from 'src/pages/SecurityQuestionnaire/securityQuestionnaire.hooks'
import { SubjectContainer } from './Subject.styles'

// Activity on a legacy AI GRC Q&A questionnaire. That page is retired, so the
// name is shown without a link.
export const QuestionnaireContent = ({
  questionnaireId,
}: {
  questionnaireId: string
}): JSX.Element => {
  const { data, error, isLoading } = useGetQuestionnaire({
    id: questionnaireId,
    includeDeleted: true,
  })

  if (!data || error || isLoading) {
    return <></>
  }

  return (
    <SubjectContainer>
      <span>{`•`}</span>
      {data.getName()}
    </SubjectContainer>
  )
}
